import React from "react";
import { useRef, useState, useEffect, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";
// import './css/AISaasV2.css'

import scopedStyle from "./css/AISaasV2.module.css";
import globalStyle from "./css/AISaasV2Global.module.css";
import { useSelector } from "react-redux";
import { Input, Button, Modal } from "antd";
import ContentFrame from "../ContentFrame";
import SharesBuy from "../components/SharesBuy";
import func from "@uikit/func";
import { fotActions } from "../../store/fot";
import LoadingOutline from "../components/LoadingOutline";
import Typed from "typed.js";
import { centToDollar } from "./util";
import { Api } from "../../uikit/service/api";
import { logEvent } from "@uikit/service/amplitude";
import useScrollToLatest from "../../custom-hooks/useScrollToLatest";
import CustomHover from "../components/CustomHover";
import { isEmpty } from "lodash";
import ToSignUpView from "../../uiview/views/toSignUp/ToSignUpView";
import { ToSignUpViewBloc } from "../../uiview/views/toSignUp/ToSignUpViewBloc";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

const caseTexter = {
  /**
   *
   * @param {string} text
   * @returns {string[]}
   */
  encode(text) {
    return text.split("\n").filter(Boolean);
    // return text.split("\n")
  },
  /**
   *
   * @param {string[]} list
   * @returns {string}
   */
  decode(list) {
    return list.join("\n").replace(/(\n)+/g, "\n");
    // return list.join("\n");
  },
};

function AppUseCase(props) {
  const { saasV2UIData } = props;
  const { appUseCase1, appUseCase2, appUseCase3, appName, newPreviewCase } = saasV2UIData;
  const appUseCaseRef = useRef(null);
  const appUseCaseInputRef = useRef(null);

  const [innerState, setInnerState] = useState({
    showInput: false,
    lastTextValue: "",
    textValue: "",
    // 触发打字机效果
    triggerTypedRefresh: 0,
  });

  const { triggerTypedRefresh, lastTextValue, textValue, showInput } = innerState;

  /**
   * @type {React.MutableRefObject<Typed | unll>}
   */
  const typedRef = useRef(null);

  useEffect(() => {
    // if (util.isEmpty(saasV2UIData.appUseCase1)) return;

    let textValue = "";
    if (newPreviewCase) {
      textValue = newPreviewCase;
    } else if (appUseCase1 || appUseCase2 || appUseCase3) {
      textValue = caseTexter.decode([appUseCase1, appUseCase2, appUseCase3]);
    }

    setInnerState(prev => ({
      ...prev,
      lastTextValue: textValue,
      textValue: textValue,
      triggerTypedRefresh: Date.now(),
    }));

    // 因为外部段落只有三段，暂不监听外部段落，只初始化外部三段段落
  }, [appName]);
  // }, [appUseCase1, appUseCase2, appUseCase3]);

  useEffect(() => {
    if (triggerTypedRefresh && appUseCaseRef.current) {
      const stringList = caseTexter.encode(lastTextValue);
      typedRef.current?.destroy();

      if (stringList.length) {
        typedRef.current = new Typed(appUseCaseRef.current, {
          strings: stringList,
          typeSpeed: 100,
          backSpeed: 0,
          backDelay: 1e3,
          startDelay: 0,
          loop: true,
        });
      }
    }

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typedRef.current?.destroy();
    };
  }, [triggerTypedRefresh]);

  const _onDBClick = () => {
    typedRef.current?.destroy();

    setInnerState(prev => ({
      ...prev,
      showInput: true,
    }));

    setTimeout(() => {
      if (!func.isEmpty(appUseCaseInputRef.current)) {
        appUseCaseInputRef.current.focus({
          cursor: "end",
        });
      }
    }, 500);

    logEvent("click_edit_appUseCase");
  };

  const _onSave = () => {
    // 保存时候去掉多余换行符
    const newTextValue = caseTexter.decode(caseTexter.encode(textValue));

    setInnerState(prev => ({
      ...prev,
      showInput: false,
      // textValue: "",

      // 组件内部更新 textValue, 不通过外部更新
      textValue: newTextValue,
      lastTextValue: newTextValue,
      triggerTypedRefresh: Date.now(),
    }));

    // 通知外部更新
    // TODO: 外部只有三段段落，暂时只更新三段，其他内部组件保存
    // const stringList = caseTexter.encode(newTextValue);
    props.onSave({
      newPreviewCase: newTextValue,
      appUseCase1: "",
      appUseCase2: "",
      appUseCase3: "",
    });
  };

  const _onCancel = () => {
    setInnerState(prev => ({
      ...prev,
      showInput: false,
      textValue: lastTextValue,
      triggerTypedRefresh: Date.now(),
    }));
  };

  const onChangeValue = e => {
    setInnerState(prev => ({
      ...prev,
      textValue: e.target.value,
    }));
  };

  const hideAndDisplay = key => {
    return key ? scopedStyle["display-block"] : scopedStyle["display-none"];
  };

  return (
    <div className={scopedStyle["appUseCase-box"]}>
      <CustomHover
        valueKey="appUseCase"
        isShare={props.isShare}
        isEdit={!showInput}
        clickEdit={_onDBClick}
        clickClose={_onCancel}
        clickSave={_onSave}
      ></CustomHover>

      <div
        className={`${scopedStyle["text-gradient-primary"]} ${hideAndDisplay(!showInput)}`}
        onDoubleClick={_onDBClick}
      >
        <span ref={appUseCaseRef}></span>
      </div>

      <Input.TextArea
        ref={appUseCaseInputRef}
        className={`title-textarea ${hideAndDisplay(showInput)} ${showInput ? scopedStyle["display-zIndex"] : null}`}
        style={{ minHeight: 80 }}
        value={textValue}
        onChange={onChangeValue}
        autoSize
        bordered={false}
      />
    </div>
  );
}

function AISaasV2(props, ref) {
  const api = new Api(false);
  const dispatch = useDispatch();
  const [showAppName, setShowAppName] = useState(true);
  const [showAppTitle, setShowAppTitle] = useState(true);
  const [showAppTagLine, setShowAppTagLine] = useState(true);
  const [showEditPlaceholder, setShowEditPlaceholder] = useState(false);
  const [AiInputLoading, setAiInputLoading] = useState(false);
  const [purchaseLoading, setPurchaseLoading] = useState(false);

  const [placeholderInput, setPlaceholderInput] = useState("");
  const [appName, setAppName] = useState(props.saasV2UIData?.appName);
  const [appTitle, setAppTitle] = useState(props.saasV2UIData?.appTitle);
  const [appTagline, setAppTagline] = useState(props.saasV2UIData?.appTagline);

  // const appUseCaseRef = useRef(null)
  const aiDescriptionInputRef = useRef(null);
  const modelBoxRef = useRef(null);
  const contentRef = useRef(null);
  const outputListRef = useRef(null);
  const appRootRef = useRef(null);
  const BgLightEffectRef = useRef(null);
  const appNameRef = useRef(null);
  const appTitleRef = useRef(null);
  const appTaglineRef = useRef(null);

  const userMe = useSelector(state => state.editor.me);
  const isLogin = useSelector(state => state.fot.isLogin);
  const showShareSignin = useSelector(state => state.fot.showShareSignin);
  const editorIdArr = useSelector(state => state.fot.editorIdArr);
  const locusEditorId = useSelector(state => state.fot.locusEditorId);
  const selectedTemplate = useSelector(state => state.studio.selectedTemplate);

  const setShowShareSignin = val => {
    dispatch(fotActions.setShowShareSignin(val));
  };
  const toSignUpViewBloc = new ToSignUpViewBloc();

  const showSubscriptionFeaturesToggle = (userMe?.feature_tags ?? []).every(x => x !== "disable_studios_subscription");
  const isPublish = selectedTemplate?.published?.author?.id === userMe.id;
  const isMobile = window.navigator.userAgent.includes("Mobile");

  useScrollToLatest({
    scrollWrapperRef: contentRef,
    scrollList: props.saasUIListData,
    selector: ".ContentFrame",
    enableScrollToImage: true,
  });

  const setHighlightData = val => {
    dispatch(fotActions.setHighlightData(val));
  };

  const onAppTitleChange = e => {
    setAppTitle(e.target.value);
  };

  const onTitlePressEnter = e => {
    e.preventDefault();
    setShowAppTitle(true);
  };

  const clickAppTitleEdit = () => {
    setShowAppTitle(false);
    if (!func.isEmpty(appTitleRef.current) && showAppTitle) {
      appTitleRef.current.focus({
        cursor: "end",
      });
    }
    logEvent("click_edit_appTitle");
  };
  const clickCloseAppTitle = () => {
    setAppTitle(props.saasV2UIData?.appTitle || "");
    setShowAppTitle(true);
  };
  const clickAppTitleSave = () => {
    setShowAppTitle(true);
    props.setSaasV2UIData(prevData => {
      return {
        ...prevData,
        appTitle: appTitle,
      };
    });
  };

  const onSaasInputChange = (e, nodeId) => {
    const newInput = props.saasUIInputData.map(x => {
      if (x.id === nodeId) {
        return {
          ...x,
          data: {
            ...x.data,
            textAreaValue: e.target.value,
          },
        };
      }
      return x;
    });
    props.setSaasV2UIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });
  };

  const onAppTagLineChange = e => {
    setAppTagline(e.target.value);
  };
  const onAppTagLinePressEnter = e => {
    e.preventDefault();
    setShowAppTagLine(true);
  };

  const handleEditplaceholderChange = e => {
    setPlaceholderInput(e.target.value);
  };

  const handleModalCancel = () => {
    setPlaceholderInput("");
    setShowEditPlaceholder(false);
  };

  const handleModalOk = () => {
    props.setSaasV2UIData(prevData => {
      return {
        ...prevData,
        placeholder: placeholderInput,
      };
    });
    handleModalCancel();
  };
  const clickBrainStudios = () => {
    window.open(`${window.location.origin}${window.location.pathname}#/editor`, "_blank");
    // window.open('https://studios.brain.ai', 'target')
  };

  const onClickTryAINow = () => {
    if (!func.isEmpty(aiDescriptionInputRef.current)) {
      aiDescriptionInputRef.current.focus();
    }
    if (props.isShare) {
      inputFocus();
      return;
    }
    if (func.isEmpty(contentRef.current) || func.isEmpty(modelBoxRef.current)) return;
    if (outputListRef.current.offsetHeight < contentRef.current.offsetHeight) {
      outputListRef.current.style.height = `${contentRef.current.offsetHeight - 120}px`;
    }
    contentRef.current.scrollTop = appRootRef.current.scrollHeight + modelBoxRef.current.scrollHeight - 40;
    logEvent("click_try_ai_now");
  };

  const onMouseOver = nodeId => {
    const obj = {
      nodeId,
    };
    setHighlightData(obj);
  };

  const inputFocus = () => {
    if (isMobile && props.isShare) {
      calcScrollDistanceTop();
    }
  };
  const calcScrollDistanceTop = () => {
    // 获取屏幕高度
    const screenHeight = document.body.scrollHeight;
    const minHeight = screenHeight - 150;
    const calculateRemoveWidth = (document.body.scrollWidth / 100) * 36.97;
    outputListRef.current.style.minHeight = `${minHeight - calculateRemoveWidth}px`;
    let inputBoxPositioning = contentRef.current.scrollHeight - minHeight;
    if (minHeight < outputListRef.current.offsetHeight) {
      inputBoxPositioning = contentRef.current.scrollHeight - outputListRef.current.scrollHeight - 165;
    }
    let myTimer = null;
    // 内容滚动条当前高度
    let scrollTo = contentRef.current.scrollTop;
    // 滚动到底部
    if (func.isEmpty(myTimer)) {
      myTimer = setInterval(() => {
        scrollTo += 50;
        if (scrollTo > inputBoxPositioning) {
          scrollTo = inputBoxPositioning;
          window.clearInterval(myTimer);
          myTimer = null;
        }
        contentRef.current.scrollTop = scrollTo;
      }, 10);
    }
  };

  const onMouseLeave = () => {
    setHighlightData({});
  };
  // useEffect(() => {
  //   if (util.isEmpty(props.saasV2UIData.appUseCase1)) return;
  //   const typed = new Typed(appUseCaseRef.current, {
  //     strings: [
  //       props.saasV2UIData.appUseCase1,
  //       props.saasV2UIData.appUseCase2,
  //       props.saasV2UIData.appUseCase3
  //     ],
  //     typeSpeed: 100,
  //     backSpeed: 0,
  //     backDelay: 1e3,
  //     startDelay: 0,
  //     loop: true
  //   })
  //   return () => {
  //     // Destroy Typed instance during cleanup to stop animation
  //     typed.destroy()
  //   }
  // }, [props.saasV2UIData.appUseCase1])

  const onKeyDown = async e => {
    if (
      props.saasUIInputData?.length === 1 &&
      e.keyCode === 13 &&
      !isEmpty(props.saasUIInputData[0].data?.textAreaValue) &&
      !AiInputLoading
    ) {
      if (!isMobile && props.isShare) {
        calcScrollDistanceTop();
      }
      setAiInputLoading(true);
      aiDescriptionInputRef.current.blur();
      await props.clickCreateContent("saasV2");
      setAiInputLoading(false);
    }
  };

  const hasEmptyInput = () => {
    return props.saasUIInputData.some(x => isEmpty(x?.data?.textAreaValue));
  };
  const clickSubmit = async () => {
    if (hasEmptyInput()) {
      func.customMsg({
        content: "Need to input something",
        type: "warning",
      });
      return;
    }
    if (!isMobile && props.isShare) {
      calcScrollDistanceTop();
    }
    setAiInputLoading(true);
    const active = document.activeElement;
    if (active.nodeName === "INPUT") {
      active?.blur();
    }
    // aiDescriptionInputRef.current.blur();
    await props.clickCreateContent("saasV2");
    setAiInputLoading(false);
  };

  useImperativeHandle(ref, () => ({
    scrollTo() {
      if (!appRootRef.current || !modelBoxRef.current) return;
      contentRef.current.scrollTo({
        top: appRootRef.current.scrollHeight + modelBoxRef.current.scrollHeight - 40, //contentRef.current.scrollHeight,
        behavior: "smooth",
      });
    },
  }));

  const clickPurchase = async () => {
    try {
      // 判断用户是否登录
      if (!isLogin) {
        setShowShareSignin(false);
        return;
      }

      // 判断当前登录用户是否为发布者
      if (selectedTemplate?.published?.author?.id === userMe.id) {
        func.messageUtil("Publishers do not need to pay fees.");
        return;
      }
      setPurchaseLoading(true);
      const index = selectedTemplate.index || selectedTemplate.uuid;
      const parmasData = {
        line_items: [
          {
            price: selectedTemplate?.published_metadata?.stripe_price_id || "",
            quantity: 1,
          },
        ],
        after_completion: {
          redirect: {
            url: `${window.location.origin}${window.location.pathname}#/editor/shared_intelligent_app/${index}?selectedUI=saasV2&stripePaymentActivated=true`,
          },
          type: "redirect",
        },
        transfer_data: {
          destination: selectedTemplate?.published_metadata?.stripe_account_id || "",
        },
      };
      // stripe激活链接
      const res = await api.postWithError("/be/payment/stripe/paymentLink", parmasData);
      if (!func.isEmpty(res?.data?.url)) {
        window.open(res.data.url, "_blank");
      }
    } catch (error) {
      func.messageUtil(error.message || "Failed to send request");
      setPurchaseLoading(false);
      console.error("error:::", error);
    }
  };

  const hideAndDisplay = key => {
    return key ? scopedStyle["display-box"] : scopedStyle["hide-box"];
  };

  const clickAppNameEdit = () => {
    setShowAppName(false);
    if (!func.isEmpty(appNameRef.current) && showAppName) {
      appNameRef.current.focus({
        cursor: "end",
      });
    }
    logEvent("click_edit_appName");
  };

  const onAppNameChange = e => {
    setAppName(e.target.value);
  };

  const onAppNamePressEnter = e => {
    e.preventDefault();
    setShowAppName(true);
    clickAppNameSave({});
  };

  const clickAppNameSave = () => {
    setShowAppName(true);
    props.setSaasV2UIData(prevData => {
      return Object.assign({}, prevData, { appName: appName });
    });
  };

  const clickCloseAppName = () => {
    setAppName(props.saasV2UIData?.appName || "");
    setShowAppName(true);
  };

  const clickAppTaglineEdit = () => {
    setShowAppTagLine(false);
    if (!func.isEmpty(appTaglineRef.current) && showAppTagLine) {
      appTaglineRef.current.focus({
        cursor: "end",
      });
    }
    logEvent("click_edit_appTagline");
  };

  const clickCloseAppTagline = () => {
    setAppTagline(props.saasV2UIData?.appTagline || "");
    setShowAppTagLine(true);
  };

  const clickAppTaglineSave = () => {
    setShowAppTagLine(true);
    props.setSaasV2UIData(prevData => {
      return Object.assign({}, prevData, { appTagline: appTagline });
    });
  };

  useEffect(() => {
    setAppName(props.saasV2UIData?.appName);
  }, [props.saasV2UIData?.appName]);

  useEffect(() => {
    setAppTitle(props.saasV2UIData?.appTitle);
  }, [props.saasV2UIData?.appTitle]);

  useEffect(() => {
    setAppTagline(props.saasV2UIData?.appTagline);
  }, [props.saasV2UIData?.appTagline]);

  useEffect(() => {
    if (props.isShare) return;
    props.setSaasV2UIData(prevData => {
      const data = {
        ...prevData,
        appName: prevData.appName || "No App Name",
        appTitle: prevData.appTitle || "AI Writer for Creating",
        appTagline:
          prevData.appTagline ||
          "AI Copywriting is revolutionizing the way content is created. AI can create content for blogs, articles, websites, social media and more.",
        inputSuggestion:
          prevData.inputSuggestion ||
          "Try your any query that requests an image, stock, videos, text answers, list of items, 3D, or whatever you want.",
      };
      setAppName(data.appName);
      setAppTitle(data.appTitle);
      setAppTagline(data.appTagline);
      return data;
    });
  }, []);

  return (
    <div className={scopedStyle["ai-saas"]}>
      <div className={scopedStyle["saas-content"]} ref={contentRef}>
        <div className={scopedStyle["app-root-box"]} ref={appRootRef}>
          <div className={scopedStyle["logo-wrap"]}>
            <img
              className={scopedStyle["logo-img"]}
              src="https://dopniceu5am9m.cloudfront.net/natural.ai/assets/svg/logo_white.svg"
            />
            <div className={scopedStyle["appName-box"]}>
              <CustomHover
                valueKey="appName"
                isShare={props.isShare}
                isEdit={showAppName}
                clickEdit={clickAppNameEdit}
                clickClose={clickCloseAppName}
                clickSave={clickAppNameSave}
              ></CustomHover>
              <div className={`${scopedStyle["saas-appName"]} ${hideAndDisplay(showAppName)}`}>{appName}</div>
              <Input.TextArea
                ref={appNameRef}
                className={`title-textarea ${hideAndDisplay(!showAppName)} ${
                  !showAppName ? scopedStyle["display-zIndex"] : null
                }`}
                value={appName}
                onChange={onAppNameChange}
                onPressEnter={onAppNamePressEnter}
                bordered={false}
                autoSize
              />
            </div>
          </div>

          <div className={scopedStyle["other-operate-box"]}>
            {props.isShare && <ToSignUpView bloc={toSignUpViewBloc}></ToSignUpView>}
          </div>

          <div className={scopedStyle["hero-content"]}>
            <div className={scopedStyle["width-limitation"]}>
              <div className={scopedStyle["title-box"]}>
                <CustomHover
                  valueKey="appTitle"
                  isShare={props.isShare}
                  isEdit={showAppTitle}
                  clickEdit={clickAppTitleEdit}
                  clickClose={clickCloseAppTitle}
                  clickSave={clickAppTitleSave}
                ></CustomHover>

                {props.saasV2Loading && !AiInputLoading ? (
                  <div className={scopedStyle["saas-top-title"]}>
                    <LoadingOutline />
                  </div>
                ) : (
                  <>
                    <div
                      className={`${scopedStyle["title"]} ${scopedStyle["app-title"]} ${hideAndDisplay(showAppTitle)}`}
                    >
                      {appTitle}
                    </div>
                    <Input.TextArea
                      ref={appTitleRef}
                      value={appTitle}
                      className={`title-textarea ${hideAndDisplay(!showAppTitle)} ${
                        !showAppTitle ? scopedStyle["display-zIndex"] : null
                      }`}
                      onChange={onAppTitleChange}
                      onPressEnter={onTitlePressEnter}
                      autoSize={{ minRows: 2, maxRows: 6 }}
                      bordered={false}
                    />
                  </>
                )}
              </div>

              <AppUseCase
                saasV2UIData={props.saasV2UIData}
                onSave={newData => {
                  props.setSaasV2UIData(prevData => {
                    return {
                      ...prevData,
                      ...newData,
                    };
                  });
                }}
              />

              <div className={scopedStyle["subtitle-box"]}>
                <CustomHover
                  valueKey="appTagline"
                  isShare={props.isShare}
                  isEdit={showAppTagLine}
                  clickEdit={clickAppTaglineEdit}
                  clickClose={clickCloseAppTagline}
                  clickSave={clickAppTaglineSave}
                ></CustomHover>

                <div className={`${scopedStyle["subtitle"]} ${hideAndDisplay(showAppTagLine)}`}>{appTagline}</div>
                <Input.TextArea
                  ref={appTaglineRef}
                  value={appTagline}
                  className={`title-textarea ${hideAndDisplay(!showAppTagLine)} ${
                    !showAppTagLine ? scopedStyle["display-zIndex"] : null
                  }`}
                  onChange={onAppTagLineChange}
                  onPressEnter={onAppTagLinePressEnter}
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  bordered={false}
                />
              </div>

              <div className={scopedStyle["button-box"]} onClick={onClickTryAINow}>
                Get Started
              </div>
            </div>
          </div>

          <div className={scopedStyle["background-light-effect"]}>
            <img
              className={scopedStyle["light-effect-top"]}
              src={`${settings.S3CDN}${settings.viewAssetsPath}saasWebTop.png`}
              alt=""
            />
            <img
              className={scopedStyle["light-effect-center"]}
              src={`${settings.S3CDN}${settings.viewAssetsPath}saasWebCenter.png`}
              alt=""
            />
            <img
              className={scopedStyle["light-effect-bottom"]}
              src={`${settings.S3CDN}${settings.viewAssetsPath}saasWebBottom.png`}
              alt=""
            />
          </div>
        </div>

        <div className={scopedStyle["moddle-box"]}>
          <div className={scopedStyle["max-width-box"]}>
            {/* 输入框 */}
            {!func.isEmpty(props.saasUIInputData) ? (
              <div className={scopedStyle["moddle-box-bgColor"]} ref={modelBoxRef}>
                <div className={scopedStyle["try-ai"]}>Try the AI here</div>
                <div className={scopedStyle["ai-content"]}>{props.saasV2UIData.inputSuggestion}</div>
                <div className={scopedStyle["ai-input-box"]}>
                  {props.saasUIInputData.map((x, index) => (
                    <Input
                      key={x.id}
                      ref={index === 0 ? aiDescriptionInputRef : undefined}
                      placeholder={x.placeholder}
                      className={scopedStyle["add-input"]}
                      value={x?.data?.textAreaValue}
                      onChange={e => onSaasInputChange(e, x.id)}
                      allowClear
                      onMouseLeave={onMouseLeave}
                      onMouseOver={() => onMouseOver(x.id)}
                      onKeyDown={onKeyDown}
                      onFocus={inputFocus}
                    />
                  ))}
                  {(props.saasUIInputData || []).length > 1 ? (
                    <div
                      className={`${scopedStyle["submit-button"]} ${hasEmptyInput() && scopedStyle["cannot-select"]}`}
                      onClick={clickSubmit}
                    >
                      {AiInputLoading ? (
                        <div className={scopedStyle["saas-loading"]}>
                          <LoadingOutline />
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </div>
                  ) : null}

                  {AiInputLoading && (props.saasUIInputData || []).length === 1 ? (
                    <div className={scopedStyle["ai-input-loading"]}>
                      <LoadingOutline />
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}

            <div className={scopedStyle["output-list"]} ref={outputListRef}>
              {props.saasUIListData.map((thought, idx) =>
                thought.results[0].type === "stock" ? (
                  <div key={idx}>
                    {editorIdArr.some(x => `saas${x.editorId}` === locusEditorId) ? (
                      <div className={scopedStyle["shares-buy"]}>
                        <SharesBuy filteredThoughts={[]} editorId={thought.results[0].nodeId} />
                      </div>
                    ) : (
                      <ContentFrame
                        id={idx}
                        isShare={props.isShare}
                        locus="saas"
                        zone="editorMode"
                        content={thought}
                        editorId={thought.results[0].nodeId}
                        select_thought={() => {}}
                        add_angle={() => {}}
                        add_like={() => {}}
                        add_dislike={() => {}}
                        ContentRetrieval={() => {}}
                        enterQuery=""
                        otherModes={["studioMode", "editorMode"]}
                      />
                    )}
                  </div>
                ) : (
                  <ContentFrame
                    className="ai-saas"
                    key={idx}
                    id={idx}
                    isShare={props.isShare}
                    locus="saas"
                    zone="editorMode"
                    content={thought}
                    editorId={thought.results[0].nodeId}
                    select_thought={() => {}}
                    add_angle={() => {}}
                    add_like={() => {}}
                    add_dislike={() => {}}
                    ContentRetrieval={() => {}}
                    enterQuery=""
                    otherModes={["studioMode", "editorMode"]}
                  />
                )
              )}
              {props.saasUIListData.length > 0 && (
                <div
                  className={`${scopedStyle["footer-brain-claimer"]} ${
                    !props.isShare ? scopedStyle["footer-brain-claimer-padding"] : null
                  }`}
                >
                  Information may be inaccurate due to its use of a General AI model.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={scopedStyle["footer-brain-studios"]}>
        <p>© 2023 {props.saasV2UIData.appName}</p>
        <p className={globalStyle["link-primary"]}>
          Built with <span onClick={clickBrainStudios}>Imagica</span> by Brain.ai
        </p>
      </div>
      {/* 支付 */}
      {!func.isEmpty(selectedTemplate?.published_metadata?.stripe_price_id) &&
      props.isShare &&
      !isPublish &&
      !props.stripePaymentActivated &&
      showSubscriptionFeaturesToggle ? (
        <div className={scopedStyle["purcharse-box"]}>
          <div className={scopedStyle["purchse-content"]}>
            <div className={scopedStyle["title"]}>
              <h3>{props.saasV2UIData.appName}</h3>
              <h3>Subscription</h3>
            </div>
            <label>Unlimited access to {props.saasV2UIData.appName}.</label>
            <div className={scopedStyle["price-box"]}>
              <h3>${centToDollar(props.subscriptionPrice?.unit_amount)}</h3>
              <div>
                <span>per</span>
                <span>
                  {props.subscriptionPrice?.recurring?.interval_count > 1
                    ? props.subscriptionPrice.recurring.interval_count
                    : ""}{" "}
                  {props.subscriptionPrice?.recurring?.interval}
                  {props.subscriptionPrice?.recurring?.interval_count > 1 ? "s" : ""}
                </span>
              </div>
            </div>
            <Button type="primary" loading={purchaseLoading} className={scopedStyle["btn"]} onClick={clickPurchase}>
              {!isLogin ? "Sign in" : "Purchase"}
            </Button>
            <footer className={scopedStyle["pur-footer"]}>
              {isLogin ? (
                <div>
                  Powered by <span className={scopedStyle["stripe"]}>stripe</span>
                </div>
              ) : null}
              {/* <div className={scopedStyle['line']}></div>
                <div className={scopedStyle["footer-link"]}>
                  <span>Terms</span>
                  <span>Privacy</span>
                </div> */}
            </footer>
          </div>
        </div>
      ) : null}
      <Modal
        title="Edit placeholder"
        open={showEditPlaceholder}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okButtonProps={{ disabled: func.isEmpty(placeholderInput) }}
      >
        <Input value={placeholderInput} onChange={handleEditplaceholderChange}></Input>
      </Modal>
    </div>
  );
}

export default React.forwardRef(AISaasV2);
